import { render, staticRenderFns } from "./DefaultCoursesView.vue?vue&type=template&id=426ffa5f&scoped=true"
import script from "./DefaultCoursesView.vue?vue&type=script&lang=js"
export * from "./DefaultCoursesView.vue?vue&type=script&lang=js"
import style0 from "./DefaultCoursesView.vue?vue&type=style&index=0&id=426ffa5f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ffa5f",
  null
  
)

export default component.exports